import "./filterControls.css";

// A titled group inside a filter drawer, with a badge showing how many of
// its filters are set so a collapsed glance still tells the story.
export const FilterSection = ({ title, count = 0, children }) => (
  <section className="filter-section" aria-label={title}>
    <div className="filter-section__head">
      <span className="filter-section__title">{title}</span>
      {count > 0 && (
        <span className="filter-section__count" aria-label={`${count} active`}>
          {count}
        </span>
      )}
    </div>
    {children}
  </section>
);

// A labelled control. `htmlFor` should point at the control's input id.
export const FilterField = ({ label, hint, htmlFor, children }) => (
  <div className="filter-field">
    {label && (
      <label className="filter-field__label" htmlFor={htmlFor}>
        {label}
        {hint && <span className="filter-field__hint">{hint}</span>}
      </label>
    )}
    {children}
  </div>
);

export default FilterSection;
